import { render, staticRenderFns } from "./company-form.vue?vue&type=template&id=115a30aa&scoped=true"
import script from "./company-form.vue?vue&type=script&lang=js"
export * from "./company-form.vue?vue&type=script&lang=js"
import style0 from "./company-form.vue?vue&type=style&index=0&id=115a30aa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115a30aa",
  null
  
)

export default component.exports